import { outOfBandThemeColors } from '@/theme/colors';
import { Box, Typography } from '@montugroup/design-system';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import StoreIcon from '@mui/icons-material/Store';
import { Grid2, styled } from '@mui/material';
import { ShippingOptionAlertPartialStock } from '../ShippingOptionCard/ShippingOptionAlertPartialStock';
import { ShippingOptionAlert } from '../ShippingOptionCard/ShippingOptionCard';

type SelectedClickAndCollectLocationCardProps = {
  selected?: boolean;
  pharmacyName?: string;
  address: string;
  hasInventory: boolean;
  deliveryRequirements?: {
    identification?: boolean;
    presence?: boolean;
  };
};

const CardContainer = styled(Box)(({ theme }) => ({
  border: `2px solid ${theme.palette.text.primary}`,
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  backgroundColor: theme.palette.background.paper,
}));

const Container = styled(Box)(({ theme }) => ({
  backgroundColor: outOfBandThemeColors.uMeds.timberGreen100,
  padding: theme.spacing(3),
}));

export function SelectedClickAndCollectLocationCard({
  pharmacyName,
  address,
  hasInventory,
  deliveryRequirements,
}: SelectedClickAndCollectLocationCardProps) {
  const [addressLine1, ...rest] = address.split(',');
  const addressLine2 = rest.join(',').trim();

  return (
    <CardContainer>
      <Container>
        <Grid2 container justifyContent={'space-between'} wrap="nowrap">
          <Grid2 container spacing={2} alignItems="flex-start" wrap="nowrap">
            <Grid2>
              <StoreIcon fontSize="small" />
            </Grid2>
            <Grid2>
              <Box display="flex" flexDirection="column" gap={2}>
                <Typography fontWeight="bold" variant="body2">
                  Click & collect
                </Typography>
                <Box>
                  <Typography variant="body2" fontWeight="bold">
                    {pharmacyName}
                  </Typography>
                  <Typography variant="body2">
                    Order now, pick up in {hasInventory ? '1 business day' : '3-7 business days'}
                  </Typography>
                </Box>
                <Grid2 container spacing={1} wrap="nowrap">
                  <Grid2>
                    <LocationOnIcon fontSize="small" />
                  </Grid2>
                  <Grid2>
                    <Typography variant="body2" fontWeight="bold">
                      {addressLine1}
                    </Typography>
                    <Typography variant="body2">{addressLine2}</Typography>
                  </Grid2>
                </Grid2>
              </Box>
            </Grid2>
          </Grid2>
          <Typography variant="body2" fontWeight="bold">
            Free
          </Typography>
        </Grid2>
      </Container>
      <ShippingOptionAlert selected deliveryRequirements={deliveryRequirements} deliveryOptionName="ClickAndCollect" />
      <ShippingOptionAlertPartialStock hasStock={hasInventory} />
    </CardContainer>
  );
}
